import React from "react";
import { FrameLabelPill } from "../atoms";
import PlayDiagram from "./PlayDiagram";

const hasPlayGeometry = (play = {}) => {
  const figures = Array.isArray(play.figureCoordinates)
    ? play.figureCoordinates
    : [];
  return (
    play.ballX !== undefined ||
    play.ballY !== undefined ||
    play.IdealPositionX !== undefined ||
    figures.length > 0
  );
};

export function PlayCard({
  title,
  image,
  timeMs,
  playNumber,
  timeMsLabel,
  playLabel,
  play = {},
  imageClassName = "",
  className = "",
  tone = "neutral",
}) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center ${className}`}
    >
      <div className="flex w-full max-w-[240px] flex-col items-center">
        {title ? (
          <p className="m-0 mb-1 flex-none text-center text-xs text-secondary">
            {title}
          </p>
        ) : null}
        <div className="aspect-[16/10] w-full max-h-[145px] overflow-hidden rounded-md">
          {hasPlayGeometry(play) ? (
            <PlayDiagram play={play} title={title} className={imageClassName} />
          ) : image ? (
            <img
              src={image}
              alt={title}
              className={`h-full w-full rounded-md bg-surface ${imageClassName}`}
            />
          ) : null}
        </div>
        <div className="mt-1.5 flex w-full flex-none items-center justify-between gap-2">
          <FrameLabelPill
            tone={tone}
            label={playLabel}
            value={playNumber}
            className="!px-2 !py-0.5 !text-[11px]"
          />
          <FrameLabelPill
            tone={tone}
            label={timeMsLabel}
            value={timeMs}
            className="!px-2 !py-0.5 !text-[11px]"
          />
        </div>
      </div>
    </div>
  );
}